module.exports = __webpack_public_path__ + "img/2-1-IMG_3001.068381dc.png";